import React from "react";
import "./Betting_Rebate_history_card.css";

function Betting_Rebate_history_card() {
  return (
    <>
      <section className="Betting_Rebate_history_card">
        <div className="history_card">
          <div className="history_header">
            <span>Lottery</span>
            <span className="completed">Completed</span>
          </div>

          <p className="date">2026-02-13 13:34:12</p>

          <div className="timeline">
            <div className="timeline_item">
              <div className="timeline_left">
                <span className="circle"></span>
              </div>
              <div className="timeline_content">
                <span>Betting Rebate</span>
                <span>₹0.00</span>
              </div>
            </div>

            <div className="timeline_item">
              <div className="timeline_left">
                <span className="circle"></span>
              </div>
              <div className="timeline_content">
                <span>Rebate rate</span>
                <span className="red">0</span>
              </div>
            </div>

            <div className="timeline_item">
              <div className="timeline_left">
                <span className="circle"></span>
              </div>
              <div className="timeline_content">
                <span>Rebate amount</span>
                <span className="orange">₹0.00</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Betting_Rebate_history_card;
